
import {Vue,Component,Prop} from 'vue-property-decorator'
declare var $: any;
@Component({
    name:"pageTitle"
})
export default class pageTitle extends Vue{
    activeMenuName=localStorage.getItem('activeMenu')
     
}
